// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChevronCircle_wrapper__3BQ_y","chevron":"ChevronCircle_chevron__frjoZ","divider":"ChevronCircle_divider__JKSQY"};